export default __webpack_public_path__ + "static/media/hk.803006af.svg";